import { IGKRapport } from "../reportSchemas/gkReportSchema";
import { LuftmengdeMaalingerEnum } from "./gkReportConstants";

export const GKRAPPORT_INIT_DATA: IGKRapport = {
  generellInfo: {
    oppdragsnavn: "",
    emne: "",
    oppdragsgiver: "",
    kontaktperson: "",
    kopi: "",
    dokumentkode: "",
    tilgjengelighet: "",
    oppdragsleder: "",
    utarbeidetAv: "",
    ansvarligEnhet: "",
    generelt: "",
    sammendrag: "",
    romNr: "",
    etasje: "",
    dato: "",
    sted: "",
    utstyr: "",
    serienummerUtstyr: "",
  },
  testInnstillinger: {
    valgteTester: {
      inneslutningsLekkasjeTestMedFotometer: false,
      luftmengdeMaalingIRom: false,
      lufthastighetskontroll: false,
      kontrollAvRomtrykk: false,
      lekkasjeskanningAvHepa: false,
      kontrollAvLuftstroem: false, //Kontroll av luftmønster
      recoveryTest: false,
      partikkelTellingIRom: false,
      partikkelTellingForUtstyr: false,
      temperaturmaaling: false,
      relativFuktighetsmaaling: false,
      kontrollAvLuftstroemVedArbeidsaapning: false,
      luftmengdemaalingGjennomArbeidsaapning: false,
      lufthastighetsmaalingOgDokuAvLaminaerLuftstroem: false,
      beregningAvLufthastighetGjennomArbeidsaapning: false,
      maalingAvTrykkfallOverHepafilter: false,
      kontrollAvAlarm: false,
      bruddtest: false,
      maalingAvLuftmengdeGjennomInntaksfilter: false,
      maalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler: false,
      lufthastighetsMaalingIArbeidsomraade: false,
      maalingAvInnstroemningsHastighet: false,
      maalingAvDriftstrykk: false,
      lekkasjetest: false,
      maalingAvLufthastighetILukeaapningRutinekontroll: false,
      maalingAvAvtrekksmengdeRutinekontroll: false,
      trykkfallIAvtrekksskap: false,
      visualiseringAvLuftstroem: false,
      testAvAlarmsystemer: false,
      testAvSkapreguleringensResponstid: false,
      maalingAvLufthastighetILukeaapningIgangkjoering: false,
      maalingAvAvtrekksmengdeIgangkjoering: false,
      maalingAvLufthastighetIRommet: false,
      maalingAvLydtrykk: false,
      maalingAvLufthastighetPunktavsug: false,
      maalingAvTrykkPunktavsug: false,
      visualiseringMedRoeykPunktavsug: false,
      eksternOgInternRoeykVisualisering: false,
      dekontamineringAvRom: false,
      dekontamineringAvSikkerhetskabinett: false,
      funksjonskontrollSikkerhetskabinett: false,
      funksjonskontrollIsolator: false,
      funksjonskontrollAvtrekksskap: false,
      maalingAvOvertrykkLAFTak: false,
      partikkelTellingUnderLAFTak: false,
      lekkasjeskanningAvHepaLAFTak: false,
      lufthastighetskontrollLAFTak: false,
      maalingAvLufthastighetVedOperasjonsseng: false,
      funksjonskontrollLAFTak: false,
    },
    valgtUtstyr: null,
    valgtRomEllerUtstyr: null,
    valgtTestValidering: null,
    valgtLuftmoenster: null,
    valgtRomAktivitet: null,
  },
  testResultater: {
    luftmengdeMaalingIRom: {
      inndata: {
        prosjektertLuftmengde: null,
        prosjektertLuftskifte: null,
        romdimensjoner: {
          romhoeyde: null,
          romareal: null,
        },
        valgtLuftmengdeMaalingsType: LuftmengdeMaalingerEnum.ANEMOMETERMAALING,
        kommentar: "",
        anemometerResultater: {
          antallTilluftsventiler: null,
          totalLuftmengde: null,
          resultaterPerVentil: [],
        },
        tilluftsKanalResultater: {
          maaleomraadeAreal: null,
          antallMaalepunkter: null,
          maaleresultater: [],
        },
        balometerResultater: {
          antallTilluftsventiler: null,
          tilluftsventilAreal: null,
          filtertype: "",
          maaleresultater: [],
        },
      },
      utdata: {
        felles: {
          romvolum: null,
          luftmengdeFraLuftskifter: null,
        },
        tilluftsKanalBeregninger: {
          arealPerMaalepunkt: null,
          totalLuftmengde: null,
        },
        balometerBeregninger: {
          totalLuftmengde: null,
        },
      },
    },
    lufthastighetskontroll: {
      inndata: {
        kommentar: "",
        antallVentiler: null,
        resultaterPerVentil: [],
      },
    },
    kontrollAvRomtrykk: {
      inndata: {
        tilleggsRomResultater: [],
        kommentar: "",
      },
    },
    kontrollAvLuftstroem: {
      //Kontroll av luftmønster
      inndata: {
        valgtMetode: "",
        kommentar: "",
        streamerMetodeResultater: {
          beskrivelseAvLuftstroem: "",
          godkjent: null,
        },
        lufthastighetsMetodeResultater: {
          maaleresultater: [null, null],
        },
      },
      utdata: {
        gjennomsnittligHastighet: null,
        varians: null,
        standardAvvik: null,
        lufthastighetUniformitet: null,
      },
    },
    lekkasjeskanningAvHepa: {
      inndata: {
        maaleresultater: [],
        kommentar: "",
      },
    },
    inneslutningsLekkasjeTestMedFotometer: {
      inndata: {
        maaleresultater: [],
        kommentar: "",
      },
    },
    recoveryTest: {
      inndata: {
        bakgrunnskonsentrasjonFoerTest: null,
        luftskifterIRommet: null,
        startkonsentrasjon: null,
        maaleresultater: [],
        kommentar: "",
      },
      utdata: {
        teoretiskUttynningstid: null,
      },
    },
    partikkelTellingIRom: {
      inndata: {
        euGmpKlasse: "",
        romAreal: null,
        isoKlasse: "",
        valgtePartikkelstoerrelser: {
          size01: false,
          size02: false,
          size03: false,
          size05: true,
          size1: false,
          size5: true,
        },
        maalehasighetTilPartikkelteller: null,
        maaletid: null,
        maaleresultater: {
          size01: [],
          size02: [],
          size03: [],
          size05: [],
          size1: [],
          size5: [],
        },
        kommentar: "",
      },
      utdata: {
        minimumAntallProevetakingspunkter: null,
        volumPerProevetaking: null,
        minimumsvolumPerProevetakingEUGMP_05: null,
        minimumsvolumPerProevetakingEUGMP_5: null,
        verdierPerProevetakingISO: [],
        klasseGrenseNivaaEUGMP_05: null,
        klasseGrenseNivaaEUGMP_5: null,
      },
    },
    partikkelTellingForUtstyr: {
      inndata: {
        euGmpKlasse: "",
        maalehasighetTilPartikkelteller: null,
        maaletid: null,
        maaleresultater: {
          size05: [
            {
              maalepunktNr: "",
              maaleresultat: null,
              sammenligningMellomKonsentrasjonOgKlassegrensenivaa: null,
            },
            {
              maalepunktNr: "",
              maaleresultat: null,
              sammenligningMellomKonsentrasjonOgKlassegrensenivaa: null,
            },
            {
              maalepunktNr: "",
              maaleresultat: null,
              sammenligningMellomKonsentrasjonOgKlassegrensenivaa: null,
            },
            {
              maalepunktNr: "",
              maaleresultat: null,
              sammenligningMellomKonsentrasjonOgKlassegrensenivaa: null,
            },
          ],
          size5: [
            {
              maalepunktNr: "",
              maaleresultat: null,
              sammenligningMellomKonsentrasjonOgKlassegrensenivaa: null,
            },
            {
              maalepunktNr: "",
              maaleresultat: null,
              sammenligningMellomKonsentrasjonOgKlassegrensenivaa: null,
            },
            {
              maalepunktNr: "",
              maaleresultat: null,
              sammenligningMellomKonsentrasjonOgKlassegrensenivaa: null,
            },
            {
              maalepunktNr: "",
              maaleresultat: null,
              sammenligningMellomKonsentrasjonOgKlassegrensenivaa: null,
            },
          ],
        },
        kommentar: "",
      },
      utdata: {
        volumPerProevetaking: null,
        minimumsvolumPerProevetakingEUGMP_05: null,
        minimumsvolumPerProevetakingEUGMP_5: null,
        klasseGrenseNivaaEUGMP_05: null,
        klasseGrenseNivaaEUGMP_5: null,
      },
    },
    temperaturmaaling: {
      inndata: {
        settpunktsTemp: null,
        maaleresultat: null,
        tidTilTempErStabil: null,
        godkjent: null,
        kommentar: "",
      },
      utdata: {
        temperaturDiff: null,
      },
    },
    relativFuktighetsmaaling: {
      inndata: {
        settpunktsLuftfuktighet: null,
        maaleresultat: null,
        tidTilLuftfuktighetErStabil: null,
        godkjent: null,
        kommentar: "",
      },
      utdata: {
        relativLuftfuktighetDiff: null,
      },
    },
    kontrollAvLuftstroemVedArbeidsaapning: {
      inndata: {
        valgtMetode: "", //Streamer eller røyk
        kommentar: "",
        resultater: {
          beskrivelseAvLuftstroem: "",
          godkjent: null,
        },
      },
    },
    luftmengdemaalingGjennomArbeidsaapning: {
      inndata: {
        arealLukeaapning: null,
        valgtMetode: "",
        kommentar: "",
        maaleresultater: [],
        avtrekkskanalResultater: {
          diameter: null,
        },
      },
      utdata: {
        gjennomsnittligHastighet: null,
        arbeidsaapningBeregninger: {
          luftmengdeGjennomLukeaapning: null,
        },
        avtrekkskanalBeregninger: {
          tverrsnittareal: null,
          arealForHvertPunkt: null,
          avkastLuftmengde: null,
        },
      },
    },
    lufthastighetsmaalingOgDokuAvLaminaerLuftstroem: {
      inndata: {
        valgtMetode: {
          lufthastighetsmaaling: false,
          dokumentasjon: false,
        },
        kommentar: "",
        lufthastighetsMaalingResultater: {
          maaleresultater: [
            {
              maaleresultat: null,
              forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
            },
            {
              maaleresultat: null,
              forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
            },
            {
              maaleresultat: null,
              forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
            },
            {
              maaleresultat: null,
              forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
            },
            {
              maaleresultat: null,
              forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
            },
            {
              maaleresultat: null,
              forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
            },
            {
              maaleresultat: null,
              forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
            },
            {
              maaleresultat: null,
              forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
            },
          ],
        },
        dokumentasjonAvLuftstroemResultater: {
          beskrivelseAvLuftstroem: "",
          godkjent: null,
        },
      },
      utdata: {
        gjennomsnittligHastighet: null,
        varians: null,
        standardAvvik: null,
        lufthastighetUniformitet: null,
      },
    },
    beregningAvLufthastighetGjennomArbeidsaapning: {
      inndata: {
        arealLukeaapning: null,
        valgtMetode: "",
        kommentar: "",
        maaleresultater: [],
        avtrekkskanalResultater: {
          diameter: null,
        },
      },
      utdata: {
        gjennomsnittligHastighet: null,
        avtrekkskanalBeregninger: {
          tverrsnittareal: null,
          arealForHvertPunkt: null,
          avkastLuftmengde: null,
        },
        lukeaapningBeregninger: {
          luftmengdeGjennomLukeaapning: null,
          varians: null,
          standardAvvik: null,
        },
      },
    },
    maalingAvTrykkfallOverHepafilter: {
      inndata: {
        maaleresultater: [],
        kommentar: "",
      },
    },
    kontrollAvAlarm: {
      inndata: {
        beskrivelseAvHvordanAlarmFremprovoseres: "",
        godkjent: null,
        kommentar: "",
      },
    },
    bruddtest: {
      inndata: {
        maaleresultatVenstre: null,
        maaleresultatHoeyre: null,
        kommentar: "",
      },
    },
    maalingAvLuftmengdeGjennomInntaksfilter: {
      inndata: {
        valgtMetode: "",
        kabinettvolum: null,
        maaleresultater: [],
        kommentar: "",
        avkastkanalResultater: {
          diameter: null,
        },
        inntaksfilterResultater: {
          arealetTilFilterflaten: null,
        },
      },
      utdata: {
        luftmengdePerVolum: null,
        avkastkanalBeregninger: {
          tverrsnittareal: null,
          arealForHvertPunkt: null,
          avkastLuftmengde: null,
        },
        inntaksfilterBeregninger: {
          gjennomsnittligHastighet: null,
          luftmengdeGjennomFilter: null,
        },
      },
    },
    maalingAvArbeidstrykkOgKontrollAvInternTrykkmaaler: {
      inndata: {
        avlestTrykkHovedkammer: null,
        maaltTrykkHovedkammer: null,
        maaltInterntrykkHoeyreSluse: null,
        avlestInterntrykkHoeyreSluse: null,
        maaltInterntrykkVenstreSluse: null,
        avlestInterntrykkVenstreSluse: null,
        ihenholdTilFabrikant: null,
        kommentar: "",
      },
      utdata: {
        trykkDiffHovedkammer: null,
        trykkDiffHoeyreSluse: null,
        trykkDiffVenstreSluse: null,
      },
    },
    lufthastighetsMaalingIArbeidsomraade: {
      inndata: {
        maaleresultater: [
          {
            maaleresultat: null,
            forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
          },
          {
            maaleresultat: null,
            forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
          },
          {
            maaleresultat: null,
            forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
          },
          {
            maaleresultat: null,
            forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
          },
          {
            maaleresultat: null,
            forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
          },
          {
            maaleresultat: null,
            forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
          },
          {
            maaleresultat: null,
            forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
          },
          {
            maaleresultat: null,
            forholdMellomMaaleresultatOgGjennomsnittshastighet: null,
          },
        ],
        displayVerdi: null,
        kommentar: "",
      },
      utdata: {
        gjennomsnittligHastighet: null,
      },
    },
    maalingAvInnstroemningsHastighet: {
      inndata: {
        maaleresultaterVenstre: {
          arealetTilFilterflaten: null,
          volum: null,
          luftskifter: null,
          innstiltInterlockTid: null,
          maaleresultater: [null, null, null, null, null],
        },
        maaleresultaterHoeyre: {
          arealetTilFilterflaten: null,
          volum: null,
          luftskifter: null,
          innstiltInterlockTid: null,
          maaleresultater: [null, null, null, null, null],
        },
        kommentar: "",
      },
      utdata: {
        beregningerVenstre: {
          gjennomsnittligHastighet: null,
          luftmengdeGjennomFilter: null,
          luftmengdeFraLuftskifter: null,
        },
        beregningerHoeyre: {
          gjennomsnittligHastighet: null,
          luftmengdeGjennomFilter: null,
          luftmengdeFraLuftskifter: null,
        },
      },
    },
    maalingAvDriftstrykk: {
      inndata: {
        avlestTrykkHovedkammer: null,
        maaltTrykkHovedkammer: null,
        maaltInterntrykkHoeyreSluse: null,
        avlestInterntrykkHoeyreSluse: null,
        maaltInterntrykkVenstreSluse: null,
        avlestInterntrykkVenstreSluse: null,
        maaltInterntrykkHovedfilter: null,
        avlestInterntrykkHovedfilter: null,
        ihenholdTilFabrikant: null,

        kommentar: "",
      },
      utdata: {
        trykkDiffHovedkammer: null,
        trykkDiffHoeyreSluse: null,
        trykkDiffVenstreSluse: null,
        trykkDiffHovedfilter: null,
      },
    },
    lekkasjetest: {
      inndata: {
        maaleresultater: [
          {
            starttrykk: null,
            sluttrykk: null,
          },
          {
            starttrykk: null,
            sluttrykk: null,
          },
          {
            starttrykk: null,
            sluttrykk: null,
          },
        ],
        godkjent: null,
        kommentar: "",
      },
    },
    maalingAvLufthastighetILukeaapningRutinekontroll: {
      inndata: {
        lufthastighetFraFabrikant: null,
        dimensjoner: {
          skapbredde: null,
          lukeaapninghoeydeHoey: null,
          lukeaapninghoeydeLav: null,
        },
        maaleresultaterHoeyLukeaapning: [
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
        ],
        maaleresultaterLavLukeaapning: [
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
        ],
        kommentar: "",
      },
      utdata: {
        beregningerHoeyLukeaapning: {
          luftmengde: null,
          gjennomsnittligHastighet: null,
          varians: null,
          standardAvvik: null,
          lukeaapningAreal: null,
        },
        beregningerLavLukeaapning: {
          gjennomsnittligHastighet: null,
          varians: null,
          standardAvvik: null,
        },
      },
    },
    maalingAvAvtrekksmengdeRutinekontroll: {
      inndata: {
        arealLukeaapning: null,
        maaleresultat: null,
        kommentar: "",
      },
      utdata: {
        avtrekksLuftmengde: null,
      },
    },
    trykkfallIAvtrekksskap: {
      inndata: {
        antallMaalepunkter: null,
        beskrivelseAvMaalepunkter: "",
        diameterPaaAvtrekkskanal: null,
        maaleresultatTilkoblingspunkt: null,
        maaleresultaterMaalenipler: [],
        avtrekksLuftmengde: null,
        kommentar: "",
      },
      utdata: {
        tverrsnittareal: null,
      },
    },
    visualiseringAvLuftstroem: {
      inndata: {
        beskrivelseAvLuftstroem: "",
        godkjent: null,
        kommentar: "",
      },
    },
    testAvAlarmsystemer: {
      inndata: {
        valgtMetode: {
          lukeaapning: false,
          lufthastighetsIndikator: false,
        },
        lukeaapningResultater: {
          godkjent: null,
          kommentar: "",
        },
        lufthastighetsIndikatorResultater: {
          godkjent: null,
          kommentar: "",
        },
      },
    },
    testAvSkapreguleringensResponstid: {
      inndata: {
        trykkfallFoerTest: null,
        trykkfallEtterTest: null,
        tidFoerTrykkfallHarRetunert: null,
        kommentar: "",
      },
    },
    maalingAvLufthastighetILukeaapningIgangkjoering: {
      inndata: {
        lufthastighetFraFabrikant: null,
        dimensjoner: {
          skapbredde: null,
          lukeaapninghoeydeHoey: null,
          lukeaapninghoeydeLav: null,
        },
        maaleresultaterHoeyLukeaapning: [
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
        ],
        maaleresultaterLavLukeaapning: [
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
          {
            maalepunktNummer: null,
            maaleresultat: null,
          },
        ],
        kommentar: "",
      },
      utdata: {
        beregningerHoeyLukeaapning: {
          luftmengde: null,
          gjennomsnittligHastighet: null,
          varians: null,
          standardAvvik: null,
          lukeaapningAreal: null,
        },
        beregningerLavLukeaapning: {
          gjennomsnittligHastighet: null,
          varians: null,
          standardAvvik: null,
        },
      },
    },
    maalingAvAvtrekksmengdeIgangkjoering: {
      inndata: {
        valgtMetode: {
          lufthastighetsmaaling: false,
          differansetrykk: false,
        },
        lukeaapningResultater: {
          lufthastighetFraFabrikant: null,
          arealLukeaapning: null,
          maaleresultater: [null, null, null, null, null, null, null, null, null],
          kommentar: "",
        },
        differanseTrykkResultater: {
          antallMaalepunkter: null,
          beskrivelseAvMaalepunkter: "",
          diameterPaaAvtrekkskanal: null,
          maaleresultatTilkoblingspunkt: null,
          maaleresultaterMaalenipler: [],
          avtrekksmengdeFraFabrikant: null,
          kommentar: "",
        },
      },
      utdata: {
        lukeaapningBeregninger: {
          gjennomsnittligHastighet: null,
          varians: null,
          standardAvvik: null,
          avtrekksmengde: null,
        },
        differanseTrykkBeregninger: {
          tverrsnittareal: null,
        },
      },
    },
    maalingAvLufthastighetIRommet: {
      inndata: {
        maaleresultater: [null, null, null, null, null, null, null, null, null, null],
        kommentar: "",
      },
    },
    maalingAvLydtrykk: {
      inndata: {
        hoeydePaaLukeaapning: null,
        maaltLydtrykk: null,
        kommentar: "",
      },
    },
    maalingAvLufthastighetPunktavsug: {
      inndata: {
        maaleresultat: null,
        kommentar: "",
      },
    },
    maalingAvTrykkPunktavsug: {
      inndata: {
        maaleresultat: null,
        kommentar: "",
      },
    },
    visualiseringMedRoeykPunktavsug: {
      inndata: {
        beskrivelseAvLuftstroem: "",
        godkjent: null,
        kommentar: "",
      },
    },
    eksternOgInternRoeykVisualisering: {
      inndata: {
        intern: {
          beskrivelseAvLuftstroem: "",
          godkjent: null,
          kommentar: "",
        },
        ekstern: {
          beskrivelseAvLuftstroem: "",
          godkjent: null,
          kommentar: "",
        },
      },
    },
    dekontamineringAvRom: {
      inndata: {
        utfoertSyklus: null,
        syklusstart: "",
        syklusslutt: "",
        hoeyestePPM: null,
        luftfuktighet: null,
        temperatur: null,
        kommentar: "",
      },
    },
    dekontamineringAvSikkerhetskabinett: {
      inndata: {
        valgtMetode: "",
        utfoertSyklus: null,
        syklusstart: "",
        syklusslutt: "",
        hoeyestePPM: null,
        luftfuktighet: null,
        temperatur: null,
        kommentar: "",
      },
    },
    funksjonskontrollSikkerhetskabinett: {
      inndata: {
        valgtMetode: {
          visuellKontrollAvOverflater: false,
          visuellKontrollAvAvtrekkskanaler: false,
          kontrollAvTilbakeslagsspjeld: false,
          maalingAvBelysning: false,
          maalingAvLydnivaaer: false,
          kontrollOgKalibrering: false,
          dekontamineringsarrangement: false,
        },
        visuellKontrollAvOverflaterResultater: {
          godkjent: null,
          kommentar: "",
        },
        visuellKontrollAvAvtrekkskanalerResultater: {
          godkjent: null,
          kommentar: "",
        },
        kontrollAvTilbakeslagsspjeldResultater: {
          godkjent: null,
          kommentar: "",
        },
        maalingAvBelysningResultater: {
          godkjent: null,
          maaleresultat: null,
          kommentar: "",
        },
        maalingAvLydnivaaerResultater: {
          godkjent: null,
          maaleresultat: null,
          kommentar: "",
        },
        kontrollOgKalibreringResultater: {
          maaltLuftmengde: null,
          maaltTrykk: null,
          avlestLuftmengde: null,
          avlestTrykk: null,
          kommentar: "",
        },
        dekontamineringsarrangement: {
          godkjent: null,
          kommentar: "",
        },
      },
    },
    funksjonskontrollIsolator: {
      inndata: {
        valgtMetode: {
          lyspaererFrontpanel: false,
          lyspaererInterlock: false,
          internvifter: false,
          eksternvifte: false,
          tilbakeslagsventil: false,
          alarmForInterntrykk: false,
          alarmForLuftvekslinger: false,
          skifteForfilterISluse: false,
          skiftePakningerSluserUtvendig: false,
          etterstrammeUtsatteKomponenter: false,
          smoereSylinder: false,
          pusseMagneter: false,
          dekontamineringsarrangement: false,
        },
        lyspaererFrontpanelResultater: {
          godkjent: null,
          kommentar: "",
        },
        lyspaererInterlockResultater: {
          godkjent: null,
          kommentar: "",
        },
        internvifterResultater: {
          godkjent: null,
          maaleresultat: null,
          kommentar: "",
        },
        eksternvifteResultater: {
          godkjent: null,
          maaleresultat: null,
          kommentar: "",
        },
        tilbakeslagsventilResultater: {
          godkjent: null,
          kommentar: "",
        },
        alarmForInterntrykkResultater: {
          godkjent: null,
          kommentar: "",
        },
        alarmForLuftvekslingerResultater: {
          godkjent: null,
          kommentar: "",
        },
        skifteForfilterISluseResultater: {
          godkjent: null,
          filterSkiftet: null,
          kommentar: "",
        },
        skiftePakningerSluserUtvendigResultater: {
          godkjent: null,
          pakningerSkiftet: null,
          kommentar: "",
        },
        etterstrammeUtsatteKomponenterResultater: {
          godkjent: null,
          kommentar: "",
        },
        smoereSylinderResultater: {
          godkjent: null,
          kommentar: "",
        },
        pusseMagneterResultater: {
          godkjent: null,
          magneterPusset: null,
          kommentar: "",
        },
        dekontamineringsarrangement: {
          godkjent: null,
          kommentar: "",
        },
      },
    },
    funksjonskontrollAvtrekksskap: {
      inndata: {
        valgtMetode: {
          kontrollAvBetjeningspanel: false,
          noedtest: false,
          lysnivaa: false,
          lydnivaa: false,
          dekontamineringsarrangement: false,
        },
        kontrollAvBetjeningspanelResultater: {
          godkjent: null,
          kommentar: "",
        },
        noedtestResultater: {
          godkjent: null,
          kommentar: "",
        },
        lysnivaaResultater: {
          godkjent: null,
          maaleresultat: null,
          kommentar: "",
        },
        lydnivaaResultater: {
          godkjent: null,
          maaleresultat: null,
          kommentar: "",
        },
        dekontamineringsarrangement: {
          godkjent: null,
          kommentar: "",
        },
      },
    },
    maalingAvOvertrykkLAFTak: {
      inndata: {
        tilleggsRomResultater: [],
        kommentar: "",
      },
    },
    partikkelTellingUnderLAFTak: {
      inndata: {
        euGmpKlasse: "",
        romAreal: null,
        isoKlasse: "",
        valgtePartikkelstoerrelser: {
          size01: false,
          size02: false,
          size03: false,
          size05: true,
          size1: false,
          size5: true,
        },
        maalehasighetTilPartikkelteller: null,
        maaletid: null,
        maaleresultater: {
          size01: [],
          size02: [],
          size03: [],
          size05: [],
          size1: [],
          size5: [],
        },
        kommentar: "",
      },
      utdata: {
        minimumAntallProevetakingspunkter: null,
        volumPerProevetaking: null,
        minimumsvolumPerProevetakingEUGMP_05: null,
        minimumsvolumPerProevetakingEUGMP_5: null,
        verdierPerProevetakingISO: [],
        klasseGrenseNivaaEUGMP_05: null,
        klasseGrenseNivaaEUGMP_5: null,
      },
    },
    lekkasjeskanningAvHepaLAFTak: {
      inndata: {
        maaleresultater: [],
        kommentar: "",
      },
    },
    lufthastighetskontrollLAFTak: {
      inndata: {
        kommentar: "",
        maaleomraadeAreal: null,
        andelFrittAreal: null,
        maaleresultater: [],
      },
      utdata: {
        minimumAntallRuterIRutenett: null,
        frittArealIHverRute: null,
        gjennomsnittligHastighet: null,
        varians: null,
        standardAvvik: null,
        totalLuftmengde: null,
        lufthastighetUniformitet: null,
      },
    },
    maalingAvLufthastighetVedOperasjonssengLAFTak: {
      inndata: {
        maaleresultater: [],
        kommentar: "",
      },
    },
    funksjonskontrollLAFTak: {
      inndata: {
        valgtMetode: {
          kontrollAvBetjeningspanel: false,
          visuellKontrollAvLyspaerer: false,
          visuellKontrollAvDisplay: false,
          visuellKontrollAvSkader: false,
          visuellKontrollAvLekkasje: false,
          visuellKontrollAvPosisjon: false,
          kontrollAvLyd: false,
          visuellKontrollAvForfilter: false,
        },
        kontrollAvBetjeningspanelResultater: {
          paaAvKnappGodkjent: null,
          flowKnappGodkjent: null,
          lysKnappGodkjent: null,
          kommentar: "",
        },
        lyspaererResultater: {
          godkjent: null,
          kommentar: "",
        },
        displayResultater: {
          godkjent: null,
          kommentar: "",
        },
        skaderResultater: {
          godkjent: null,
          kommentar: "",
        },
        lekkasjeResultater: {
          godkjent: null,
          kommentar: "",
        },
        posisjonResultater: {
          godkjent: null,
          kommentar: "",
        },
        lydResultater: {
          godkjent: null,
          kommentar: "",
        },
        forfilterResultater: {
          godkjent: null,
          kommentar: "",
        },
      },
    },
  },
};
